import { API_URL } from '../../../app-config/constants';
import { UserListDto } from '../../../types/UserDtos';
import { get } from '../request';

const RESOURCE = `${API_URL}/users`;

getSwitchableUsers.operation = 'READ';
export function getSwitchableUsers() {
    return get<UserListDto[]>(`${RESOURCE}/switchable`);
}
